import { render } from "./Title2.vue?vue&type=template&id=513390de&scoped=true"
import script from "./Title2.vue?vue&type=script&lang=js"
export * from "./Title2.vue?vue&type=script&lang=js"

import "./Title2.vue?vue&type=style&index=0&id=513390de&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513390de"]])

export default __exports__